export const REQUEST_GET_MEDIA = 'REQUEST_GET_MEDIA';
export const SUCCESS_GET_MEDIA = 'SUCCESS_GET_MEDIA';
export const FAILURE_GET_MEDIA = 'FAILURE_GET_MEDIA';
